import { isWeekend, addDays, startOfDay } from "date-fns";

const easterSunday = (y) => {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
  const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(y, month - 1, day);
};

const FIXED = ["01-01", "01-06", "04-25", "05-01", "06-02", "08-15", "11-01", "12-08", "12-25", "12-26"];

export const isItalianHoliday = (date) => {
  const mmdd = `${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  if (FIXED.includes(mmdd)) return true;
  const e = easterSunday(date.getFullYear());
  const pasquetta = addDays(e, 1);
  return (date.getMonth() === e.getMonth() && date.getDate() === e.getDate()) ||
    (date.getMonth() === pasquetta.getMonth() && date.getDate() === pasquetta.getDate());
};

export const isNonWorkingDay = (date, closures = []) => {
  if (isWeekend(date) || isItalianHoliday(date)) return true;
  const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  return closures.includes(key);
};

export const addWorkingDays = (start, n, closures = []) => {
  let d = startOfDay(start);
  let added = 0;
  while (added < n) {
    d = addDays(d, 1);
    if (!isNonWorkingDay(d, closures)) added += 1;
  }
  return d;
};

// Giorni lavorativi minimi (Tempistiche) per un ordine esistente, in base alle sue lavorazioni
export const orderMinWorkingDays = (order, options = {}, ctype = "laboratorio") => {
  if (!order) return 1;
  const dbt = options.deadline_by_type || {};
  const items = order.items || [];
  const types = items.filter((it) => it.type).map((it) => it.type);
  if (!types.length) [order.design_type, order.material].forEach((t) => t && types.push(t));
  const vals = types.map((t) => { const e = dbt[t]; const v = e ? (e[ctype] ?? e.laboratorio) : null; return v ? Number(v) : null; }).filter((v) => v > 0);
  if (vals.length) return Math.max(...vals);
  const dd = options.deadline_days || {};
  const num = (v, d) => { const n = parseInt(v, 10); return isNaN(n) ? d : n; };
  const s = `${types.join(" ")} ${order.macro_category || ""}`.toLowerCase();
  if (s.includes("toronto")) return num(dd.toronto, 5);
  if (order.macro_category === "Stampa 3D") return num(dd.stampa_3d, 1);
  const q = items.length ? items.reduce((a, it) => a + (parseInt(it.quantity, 10) || 0), 0) : (parseInt(order.quantity, 10) || 14);
  if (order.macro_category) return q >= 5 ? num(dd.progettazione_5_plus, 3) : num(dd.progettazione_1_4, 2);
  return num(dd.stampa_3d, 1);
};

// Riassunto delle chiusure laboratorio future (es. "3–12 nov, 24 dic") per avvisare il cliente
export const upcomingClosuresLabel = (closures = [], horizonDays = 90) => {
  const today = new Date().toISOString().slice(0, 10);
  const limit = addDays(new Date(), horizonDays).toISOString().slice(0, 10);
  const days = [...new Set(closures)].filter((k) => k >= today && k <= limit).sort();
  if (!days.length) return "";
  const groups = [];
  for (const k of days) {
    const d = new Date(k + "T00:00:00");
    const last = groups[groups.length - 1];
    if (last && (d - last.end) / 86400000 <= 3) last.end = d; else groups.push({ start: d, end: d });
  }
  const f = (d) => d.toLocaleDateString("it-IT", { day: "numeric", month: "short" });
  return groups.map((g) => (g.start.getTime() === g.end.getTime() ? f(g.start) : `${f(g.start).split(" ")[0]}–${f(g.end)}`)).join(", ");
};
